var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"content-wraper switch"},[_c('style-switch')],1),_c('div',{staticClass:"content-wraper flex-around content-trade"},[_c('block-list',{staticClass:"home-records",attrs:{"blockList":_vm.blockList}}),_c('tx-list',{attrs:{"txList":_vm.txList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }